"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcProgressBarBehavior = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_progress_bar_constants_1 = require("./bc-progress-bar-constants");
var bc_progress_bar_constants_2 = require("./bc-progress-bar-constants");
var bc_progress_bar_constants_3 = require("./bc-progress-bar-constants");
var bc_progress_bar_constants_4 = require("./bc-progress-bar-constants");
var bc_progress_bar_constants_5 = require("./bc-progress-bar-constants");
var bc_progress_bar_constants_6 = require("./bc-progress-bar-constants");
var bc_progress_bar_constants_7 = require("./bc-progress-bar-constants");
var bc_progress_bar_constants_8 = require("./bc-progress-bar-constants");
var bc_progress_bar_constants_9 = require("./bc-progress-bar-constants");
var bc_progress_bar_constants_10 = require("./bc-progress-bar-constants");
var bc_progress_bar_constants_11 = require("./bc-progress-bar-constants");
var bc_progress_bar_constants_12 = require("./bc-progress-bar-constants");
var bc_progress_bar_constants_13 = require("./bc-progress-bar-constants");
var bc_progress_bar_constants_14 = require("./bc-progress-bar-constants");
var bc_progress_bar_constants_15 = require("./bc-progress-bar-constants");
var bc_progress_bar_constants_16 = require("./bc-progress-bar-constants");
var BcProgressBarBehavior = (function (_super) {
    __extends(BcProgressBarBehavior, _super);
    function BcProgressBarBehavior() {
        return _super.call(this) || this;
    }
    BcProgressBarBehavior.setUpAll = function () {
        var progressElements = Array.from(document.querySelectorAll("[class^='".concat(bc_progress_bar_constants_15.BC_PROGRESS_BAR_ELEMENT, "']")));
        var elements = [];
        progressElements.forEach(function (element) {
            var progress = new BcProgressBarBehavior();
            progress.setElement(element);
            progress.setUp();
            elements.push(progress);
        });
        return elements;
    };
    BcProgressBarBehavior.prototype._setUp = function () {
        this.createProgresBar();
        this.setProgress(parseFloat(this.getValueProgress()));
        this.setColor(this.getColorProgress());
        this.setDiameter(parseFloat(this.getDiameter()));
        this.setOrientation(this.getOrientation());
    };
    BcProgressBarBehavior.prototype.setOrientation = function (orientation) {
        if (this.getTypeProgress() === bc_progress_bar_constants_1.BC_LINEAL) {
            if (orientation === bc_progress_bar_constants_1.VERTICAL) {
                this.getMySelf().style.transform = "rotate(90deg)";
                this.getMySelf().style.transformOrigin = '6px 100%';
            }
            else {
                this.getMySelf().style.transform = "rotate(0deg)";
            }
        }
    };
    BcProgressBarBehavior.prototype.setStroke = function (stroke) {
        var typeProgress = this.getTypeProgress();
        if (typeProgress === bc_progress_bar_constants_1.BC_CIRCLE || typeProgress === bc_progress_bar_constants_1.BC_SEMI_CIRCLE) {
            var circleContainerBackground = this.mySelf.querySelector(".".concat(bc_progress_bar_constants_2.BC_PROGRESS_BAR_CIRCLE_CONTAINER_BACKGROUND));
            var circleContainerProgress = this.getMySelf().querySelector(".".concat(bc_progress_bar_constants_3.BC_PROGRESS_BAR_CIRCLE_CONTAINER_PROGRESS));
            var semiCircleContainerBackground = this.mySelf.querySelector(".".concat(bc_progress_bar_constants_5.BC_PROGRESS_BAR_SEMICIRCLE_CONTAINER_BACKGROUND));
            var semiCircleContainerProgress = this.getMySelf().querySelector(".".concat(bc_progress_bar_constants_6.BC_PROGRESS_BAR_SEMICIRCLE_CONTAINER_PROGRESS));
            if (circleContainerBackground) {
                circleContainerBackground['style'].strokeWidth = String(stroke);
            }
            if (circleContainerProgress) {
                circleContainerProgress.style.strokeWidth = String(stroke);
            }
            if (semiCircleContainerBackground) {
                semiCircleContainerBackground['style'].strokeWidth = String(stroke);
            }
            if (semiCircleContainerProgress) {
                semiCircleContainerProgress.style.strokeWidth = String(stroke);
            }
        }
    };
    BcProgressBarBehavior.prototype.setDiameter = function (diameter) {
        switch (this.getTypeProgress()) {
            case bc_progress_bar_constants_1.BC_SEMI_CIRCLE:
                this.setDiameterSemiCircle(diameter);
                break;
            case bc_progress_bar_constants_1.BC_CIRCLE:
                this.setDiameterCircle(diameter);
        }
    };
    BcProgressBarBehavior.prototype.setDiameterSemiCircle = function (diameter) {
        this.getMySelf().querySelector(bc_progress_bar_constants_1.SVG).style.width = diameter;
        this.getMySelf().querySelector(bc_progress_bar_constants_1.SVG).style.height = diameter;
    };
    BcProgressBarBehavior.prototype.setDiameterCircle = function (diameter) {
        this.getMySelf().querySelector(bc_progress_bar_constants_1.SVG).style.width = diameter;
        this.getMySelf().querySelector(bc_progress_bar_constants_1.SVG).style.height = diameter;
    };
    BcProgressBarBehavior.prototype.createProgresBar = function () {
        switch (this.getTypeProgress()) {
            case bc_progress_bar_constants_1.BC_LINEAL:
                this.createProgressLineal();
                break;
            case bc_progress_bar_constants_1.BC_SEMI_CIRCLE:
                this.createProgressSemiCircle();
                break;
            case bc_progress_bar_constants_1.BC_CIRCLE:
                this.createProgressCircle();
        }
    };
    BcProgressBarBehavior.prototype.setProgress = function (progress) {
        switch (this.getTypeProgress()) {
            case bc_progress_bar_constants_1.BC_LINEAL:
                this.changeProgressLineal(progress);
                break;
            case bc_progress_bar_constants_1.BC_SEMI_CIRCLE:
                this.changeProgressSemiCircle(progress);
                break;
            case bc_progress_bar_constants_1.BC_CIRCLE:
                this.changeProgressCircle(progress);
        }
    };
    BcProgressBarBehavior.prototype.setColor = function (color) {
        if (!bc_progress_bar_constants_13.PERMITED_COLORS.includes(this.getColorProgress())) {
            throw new Error('Color no disponible.');
        }
        switch (this.getTypeProgress()) {
            case bc_progress_bar_constants_1.BC_LINEAL:
                this.changeColorLineal(color);
                break;
            case bc_progress_bar_constants_1.BC_SEMI_CIRCLE:
                this.changeColorSemiCircle(color);
                break;
            case bc_progress_bar_constants_1.BC_CIRCLE:
                this.changeColorCircle(color);
        }
    };
    BcProgressBarBehavior.prototype.changeColorCircle = function (color) {
        this.removeCurrentColor(this.getMySelf().querySelector(bc_progress_bar_constants_1.SVG));
        this.getMySelf().querySelector(bc_progress_bar_constants_1.SVG).classList.add("".concat(bc_progress_bar_constants_9.BC_PROGRESS_BAR_CONTAINER, "-").concat(color));
    };
    BcProgressBarBehavior.prototype.changeColorSemiCircle = function (color) {
        this.removeCurrentColor(this.getMySelf().querySelector(bc_progress_bar_constants_1.SVG));
        this.getMySelf().querySelector(bc_progress_bar_constants_1.SVG).classList.add("".concat(bc_progress_bar_constants_9.BC_PROGRESS_BAR_CONTAINER, "-").concat(color));
    };
    BcProgressBarBehavior.prototype.changeColorLineal = function (color) {
        this.removeCurrentColor(this.getMySelf().querySelector(common_constants_1.BcCommonConstants.DIV_TAG));
        this.getMySelf().querySelector(common_constants_1.BcCommonConstants.DIV_TAG).classList.add("".concat(bc_progress_bar_constants_9.BC_PROGRESS_BAR_CONTAINER, "-").concat(color));
    };
    BcProgressBarBehavior.prototype.removeCurrentColor = function (element) {
        element.classList.forEach(function (classElement) {
            if (classElement.startsWith("".concat(bc_progress_bar_constants_9.BC_PROGRESS_BAR_CONTAINER))) {
                element.classList.remove(classElement);
            }
        });
    };
    BcProgressBarBehavior.prototype.createProgressCircle = function () {
        this.getMySelf().innerHTML += bc_progress_bar_constants_12.CIRCLE_TEMPLATE;
        var diameter = parseFloat(this.getDiameter());
        var radio = diameter / bc_progress_bar_constants_8.BC_HALF_DIAMETER - parseFloat(this.getStroke()) / bc_progress_bar_constants_8.BC_HALF_DIAMETER;
        var svg = this.getMySelf().querySelector(bc_progress_bar_constants_1.SVG);
        var circleContainerBackground = this.getMySelf().querySelector(".".concat(bc_progress_bar_constants_2.BC_PROGRESS_BAR_CIRCLE_CONTAINER_BACKGROUND));
        var circleContainerProgress = this.getMySelf().querySelector(".".concat(bc_progress_bar_constants_3.BC_PROGRESS_BAR_CIRCLE_CONTAINER_PROGRESS));
        svg.setAttribute('viewBox', "0 0 ".concat(diameter, " ").concat(diameter));
        svg.classList.add("".concat(this.getBackgroundColor()));
        if (circleContainerBackground) {
            circleContainerBackground.setAttribute('r', String(radio));
            circleContainerBackground.style.strokeWidth = String(this.getStroke());
        }
        if (circleContainerProgress) {
            circleContainerProgress.setAttribute('r', String(radio));
            circleContainerProgress.style.strokeWidth = String(this.getStroke());
        }
        this.getMySelf().style.position = 'relative';
        this.getMySelf().style.width = String(diameter + 'px');
        this.getMySelf().style.height = String(diameter + 'px');
        var content = this.getMySelf().querySelector(".".concat(bc_progress_bar_constants_11.BC_PROGRESS_BAR_CONTENT));
        if (content) {
            content.style.position = 'absolute';
            content.style.top = '50%';
            content.style.left = '50%';
            content.style.transform = 'translate(-50%, -50%)';
        }
    };
    BcProgressBarBehavior.prototype.createProgressSemiCircle = function () {
        this.getMySelf().innerHTML += bc_progress_bar_constants_14.SEMI_CIRCLE_TEMPLATE;
        var diameter = parseFloat(this.getDiameter());
        var radio = diameter / bc_progress_bar_constants_8.BC_HALF_DIAMETER - parseFloat(this.getStroke()) / bc_progress_bar_constants_8.BC_HALF_DIAMETER;
        var svg = this.getMySelf().querySelector(bc_progress_bar_constants_1.SVG);
        var circleContainerBackground = this.getMySelf().querySelector(".".concat(bc_progress_bar_constants_5.BC_PROGRESS_BAR_SEMICIRCLE_CONTAINER_BACKGROUND));
        var circleContainerProgress = this.getMySelf().querySelector(".".concat(bc_progress_bar_constants_6.BC_PROGRESS_BAR_SEMICIRCLE_CONTAINER_PROGRESS));
        svg.setAttribute('viewBox', "0 0 ".concat(diameter, " ").concat(diameter));
        svg.classList.add("".concat(this.getBackgroundColor()));
        if (circleContainerBackground) {
            circleContainerBackground.setAttribute('r', String(radio));
            circleContainerBackground.style.strokeWidth = String(this.getStroke());
        }
        if (circleContainerProgress) {
            circleContainerProgress.setAttribute('r', String(radio));
            circleContainerProgress.style.strokeWidth = String(this.getStroke());
        }
        this.getMySelf().style.position = 'relative';
        this.getMySelf().style.width = String(diameter + 'px');
        this.getMySelf().style.height = String(diameter + 'px');
        var content = this.getMySelf().querySelector(".".concat(bc_progress_bar_constants_11.BC_PROGRESS_BAR_CONTENT));
        if (content) {
            content.style.position = 'absolute';
            content.style.top = '50%';
            content.style.left = '50%';
            content.style.transform = 'translate(-50%, -50%)';
        }
    };
    BcProgressBarBehavior.prototype.createProgressLineal = function () {
        var _a;
        this.getMySelf().innerHTML += bc_progress_bar_constants_16.LINEAL_TEMPLATE;
        (_a = this.getMySelf().querySelector(common_constants_1.BcCommonConstants.DIV_TAG)) === null || _a === void 0 ? void 0 : _a.classList.add("".concat(this.getBackgroundColor()));
    };
    BcProgressBarBehavior.prototype.changeProgressLineal = function (progress) {
        var progressBarLieal = this.getMySelf().querySelector(".".concat(bc_progress_bar_constants_4.BC_PROGRESS_BAR_LINEAL_VALUE));
        if (progressBarLieal) {
            progressBarLieal.style.width = progress + '%';
        }
    };
    BcProgressBarBehavior.prototype.changeProgressSemiCircle = function (progress) {
        var progressValue = this.computeProgressValue(progress);
        var semiCircleContainer = this.getMySelf().querySelector(".".concat(bc_progress_bar_constants_6.BC_PROGRESS_BAR_SEMICIRCLE_CONTAINER_PROGRESS));
        if (semiCircleContainer) {
            semiCircleContainer.style.strokeDashoffset = progressValue.toString();
        }
    };
    BcProgressBarBehavior.prototype.changeProgressCircle = function (progress) {
        var progressValue = this.computeProgressValue(progress);
        var progressContainer = this.getMySelf().querySelector(".".concat(bc_progress_bar_constants_3.BC_PROGRESS_BAR_CIRCLE_CONTAINER_PROGRESS));
        if (progressContainer) {
            progressContainer.style.strokeDashoffset = progressValue.toString();
        }
    };
    BcProgressBarBehavior.prototype.getTypeProgress = function () {
        return this.getMySelf().getAttribute('type');
    };
    BcProgressBarBehavior.prototype.getValueProgress = function () {
        return this.getMySelf().getAttribute('value');
    };
    BcProgressBarBehavior.prototype.getColorProgress = function () {
        return String(this.getMySelf().getAttribute('color'));
    };
    BcProgressBarBehavior.prototype.getDiameter = function () {
        return this.getMySelf().getAttribute('diameter');
    };
    BcProgressBarBehavior.prototype.getStroke = function () {
        return this.getMySelf().getAttribute('stroke') || bc_progress_bar_constants_7.BC_DEFAULT_STROKE_WIDTH;
    };
    BcProgressBarBehavior.prototype.getBackgroundColor = function () {
        return this.getMySelf().getAttribute('background-color') || 'light';
    };
    BcProgressBarBehavior.prototype.getOrientation = function () {
        return this.getMySelf().getAttribute('orientation') || bc_progress_bar_constants_1.HORIZONTAL;
    };
    BcProgressBarBehavior.prototype.computeProgressValue = function (val) {
        if (this.getTypeProgress() === bc_progress_bar_constants_1.BC_SEMI_CIRCLE) {
            return Math.abs(bc_progress_bar_constants_10.BC_THREE_QUARTER_CIRCLE - (val * bc_progress_bar_constants_10.BC_THREE_QUARTER_CIRCLE) / bc_progress_bar_constants_1.BC_COMPLETE_CIRCLE);
        }
        else {
            return Math.abs(bc_progress_bar_constants_1.BC_COMPLETE_CIRCLE - val);
        }
    };
    return BcProgressBarBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcProgressBarBehavior = BcProgressBarBehavior;
